<input
type="checkbox"
class="form-check-input"
[checked]="property"
disabled
/>


